import {DeltaHandler} from "../../../infrastructure/handlers/delta-handler";
import {PartialGameRequestParams} from "../../../domain/partial-game/models/partial-game.request-params";
import {PartialGameDomainService} from "../../../domain/partial-game/services/partial-game.domain.service";
import {DatetimeUtils} from "../../../infrastructure/utils/datetime-utils";
import {PARTIAL_GAME_DOMAIN} from "../../../domain/partial-game/partial-game.domain.consts";
import {COMPETITIONS_SLIDER_WIDGET} from "../competition-slider-widget.consts";
import {CompetitionsSliderWidgetController} from "../competitions-slider-widget.controller";
import {CompetitionsSliderWidgetState} from "../models/competitions-slider-widget.state";

export class CompetitionsSliderWidgetPartialGamesFetchHandler extends DeltaHandler {
  controller: CompetitionsSliderWidgetController;
  state: CompetitionsSliderWidgetState;
  type = COMPETITIONS_SLIDER_WIDGET.ACTION_TYPES.fetchGames;

  static injectables = [PartialGameDomainService, DatetimeUtils];

  constructor(domainService: PartialGameDomainService, datetimeUtils: DatetimeUtils) {
    super(domainService);

    this.datetimeUtils = datetimeUtils;
  }

  get requestParams(): PartialGameRequestParams {
    const isTopGames = this.state.selectedCompetitionId === COMPETITIONS_SLIDER_WIDGET.DEFAULT_COMPETITION_TOP_GAMES_ID;
    const competitions = isTopGames ? this.controller.props.competitionIds?.filter((id: Number) => id !== COMPETITIONS_SLIDER_WIDGET.DEFAULT_COMPETITION_TOP_GAMES_ID) : [this.state.selectedCompetitionId];
    const showOdds: Boolean = this.controller.props.showOdds;
    const filterName: String = PARTIAL_GAME_DOMAIN.filters.slider;
    const topBookmaker = this.state.appState.topBookmakerId;

    const requestParams: PartialGameRequestParams = new PartialGameRequestParams(null, competitions, null, null, null, null, null, filterName, null, showOdds, null, null,null,null,null, null, null, null, null, null, null, topBookmaker);

    return requestParams;
  }

  async action() {
    const response = await super.fetch();

    this.state.dataSource = response;

    return response;
  }
}
